module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/platforms.9d8495c8d3e60871ac5dbf3ceaba2720.jpg";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/platforms.jpg
// module id = 1718
// module chunks = 1